import styled from 'styled-components';

const Wrapper = styled.div`
  .divider {
    border-top: 1px solid ${(props) => props.theme.colors.grey};
    opacity: 0.3;
    margin-top: 20px;
    width: 100%;
  }

  .loading {
    font-style: italic;
    padding: 10px 16px;
    font-family: ManropeLight, sans-serif;
    font-size: 13px;
    cursor: default;
    color: ${(props) => props.theme.colors.grey};
  }

  form {
    display: flex;
    flex-direction: column;

    .device-configs-container {
      display: flex;
      flex-direction: column;
      width: 100%;
      padding-bottom: 24px;

      .form-title {
        font-family: ManropeLight, sans-serif;
        font-size: 13px;
      }

      p.message {
        max-width: 50%;
      }

      .groupName {
        font-family: ManropeLight, sans-serif;
        font-size: 13px;
        margin: 10px 0;
      }
    }

    button {
      min-width: 135px;
      padding: 16px 30px;
      justify-content: center;
    }

    .actions-container {
      display: flex;
      justify-content: space-between;
      .save-button {
        background-color: ${(props) => props.theme.colors.main_cta};
        color: ${(props) => props.theme.colors.widget_background};

        &:hover {
          background-color: ${(props) => props.theme.colors.widget_hover_background};
          color: ${(props) => props.theme.colors.main_cta};
        }

        &:disabled {
          cursor: default;
          background-color: ${(props) => props.theme.colors.inactive};
          color: ${(props) => props.theme.colors.black};
        }
      }
    }
  }

  p.loading {
    font-style: italic;
    font-size: 14px;
    margin-top: 100px;
    text-align: center;
  }

  p.message {
    font-style: italic;
    font-size: 12px;
    margin-top: 10px;
  }

  p.error {
    color: ${(props) => props.theme.colors.red};
  }

  p.warning {
    color: ${(props) => props.theme.colors.orange};
  }

  .hidden {
    display: none;
  }
`;

const RowContainer = styled.div<{ $hide?: boolean; }>`
  width: 100%;
  max-width: 100%;
  display: ${(props) => (props.$hide ? 'none' : 'flex')};
  gap: 16px;

  .input-component {
    width: 100%;
    margin-top: 5px;
  }
`;

const ErrorMessage = styled.p`
  color: ${(props) => props.theme.colors.red};
  text-align: center;
  font-family: ManropeLight, sans-serif;
`;

export default { Wrapper, RowContainer, ErrorMessage };
